import { Component, OnInit, AfterViewChecked } from "@angular/core";
import { environment } from "@edp-environments/environment";
import { DeviceDetectorService } from "ngx-device-detector";
import { ExternalLinkService } from "@edp-directives/external-link/external-link.service";
import { TranslateService } from "@ngx-translate/core";
import { AndroidApp } from "@edp-models/app.model";
import { AppService } from "@edp-services/app.service";

@Component({
    selector: "edp-redy-card-bar",
    templateUrl: "./edp-redy-card-bar.component.html",
    styleUrls: ["./edp-redy-card-bar.component.scss"]
})
export class EdpRedyCardBarComponent implements OnInit, AfterViewChecked {

    public isApp: boolean;
    public isAndroid: boolean;
    public displayRedyCard: boolean;
    public cardDescription: string;
    public contractHasRedy: boolean;

    constructor(
        public deviceDetector: DeviceDetectorService,
        private externalLink: ExternalLinkService,
        private translateService: TranslateService,
        private appService: AppService
    ) { }

    ngOnInit(): void {

        this.isApp = environment.isApp;
        this.isAndroid = this.deviceDetector.os === "Android";

        if (this.isApp) {
            this.cardDescription = this.isAndroid
                                    ? "pt.edp.edponline.card.bar.consumptions.description.app"
                                    : "pt.edp.edponline.card.bar.consumptions.description.app.ios";
        } else {
            this.cardDescription = "pt.edp.edponline.card.bar.consumptions.description";
        }
    }

    public open(): void {
        if (this.isApp) {
            let app: string | AndroidApp;
            if (this.isAndroid) {
                app = {
                    application: "pt.edp.edpc.redy",
                    package: "pt.edp.edpc.redy"
                } as AndroidApp;

                this.appService.openApp(app);
            } else {
                this.appService.openExternalLink("pt.edp.edpc.redy://");
            }

        } else {
            this.externalLink.externalLink(this.translateService.instant("pt.edp.edponline.card.bar.consumptions.link"));
        }
    }

    ngAfterViewChecked() {
        this.displayRedyCard = location.pathname.includes("/consumos") && this.contractHasRedy;
    }
}
